import { UseFormRegister, FieldValues, FieldErrors } from "react-hook-form";
import { Rules } from "../../types/integrations";
import { Field, FieldLabel, FieldError } from "../ui/field";

interface SelectProps {
  label: string;
  name: string;
  rules: Rules;
  errors: FieldErrors<FieldValues>;
  register: UseFormRegister<FieldValues>;
  hidden?: boolean;
  options: {
    name: string;
    value: string;
  }[];
}

export const FormSelect = ({
  label,
  options,
  name,
  register,
  rules,
  errors,
  hidden
}: SelectProps) => {
  if (hidden) return null;

  return (
    <Field>
      <FieldLabel htmlFor={name}>
        {label}
      </FieldLabel>
      <select
        id={name}
        {...register(name, rules)}
        className="flex h-10 w-full rounded-[12px] border border-input bg-background pl-3 pr-10 py-2 text-[13px] ring-offset-background focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50"
        aria-invalid={!!errors[name]}
      >
        {options.map(({ name, value }) => (
          <option value={value} key={name}>
            {name}
          </option>
        ))}
      </select>
      {errors[name] && (
        <FieldError>{`${errors[name]?.message}`}</FieldError>
      )}
    </Field>
  );
};
